
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/best-ai-video-tools-cinematic-travel-videos-2026",
      function () {
        return require("private-next-pages/blog/best-ai-video-tools-cinematic-travel-videos-2026.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/best-ai-video-tools-cinematic-travel-videos-2026"])
      });
    }
  